import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const ComponentRadio = ({ name, value, label, onSelected, classes = '', error, defaultChecked = false }) => (_jsxs("div", Object.assign({ style: { display: 'inline-block' } }, { children: [_jsx("input", { type: 'radio', name: name, id: `${name}-${value}`, value: value, onChange: () => onSelected(value), defaultChecked: defaultChecked }), _jsxs("label", Object.assign({ htmlFor: `${name}-${value}`, className: classes }, { children: [label, error && _jsx("p", Object.assign({ className: 'is-invalid-label' }, { children: error }))] }))] })));
ComponentRadio.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
        PropTypes.number
    ]).isRequired,
    label: PropTypes.string.isRequired,
    onSelected: PropTypes.func.isRequired,
    classes: PropTypes.string,
    error: PropTypes.string
};
export default ComponentRadio;
